export enum LayoutType {
  Fullscreen = 'Fullscreen',
  PublicFullscreen = 'PublicFullscreen',
  Card = 'Card',
  Blank = 'Blank',
}
